const formatter = Intl.NumberFormat('en-US', { notation: 'compact' });

export const formatCount = (count: number) =>
  formatter.format(count).toLowerCase();
